import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router';
import styles from './BlogFeaturedPost.css';

class BlogFeaturedPost extends Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
  };

  render() {
    const { post } = this.props;

    return (
      <div>
        <Link to={`/journal/${post.title}`}>
          <div className={styles.featuredImg}>
            {post.featuredImg && (
              <div className={styles.content} style={{ backgroundImage: `url(${post.featuredImg.url}?w=1040&fm=jpg&fl=progressive)` }} />
            )}
            {!post.featuredImg && (
              <div className={classnames(styles.content, styles.placeholder)} />
            )}
          </div>
          <p className={styles.featuredStoryLabel}>Featured Story</p>
          <p className={styles.postTitle}>{post.title}</p>
          <div className="row">
            <div className="col--s-2of12" style={{ height: '1px' }} />
            <div className="col--s-8of12">
              <p className={styles.postExtract}>{post.extract}</p>
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

export default BlogFeaturedPost;



// WEBPACK FOOTER //
// ./src/components/blog-featured-post/BlogFeaturedPost.js